import React from 'react';

const ContactPage = () => {
  const googleMapsEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.0900000000007!2d-72.48999999999999!3d7.8999999999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e6645f000000001%3A0x8e6645f000000001!2sCl.%200%20Nte.%20%236-02%2C%20Villa%20Del%20Rosario%2C%20Norte%20de%20Santander%2C%20Colombia!5e0!3m2!1sen!2sus!4v1678888888888!5m2!1sen!2sus"; // Placeholder URL, replace with actual embed URL for Cl. 0 Nte. #6-02, Villa Del Rosario, Norte de Santander - Colombia

  return (
    <div className="bg-background min-h-screen p-4 sm:p-8">
      <h1 className="text-3xl sm:text-4xl font-bold text-textPrimary mb-8 sm:mb-10 text-center">Contáctanos</h1>
      <div className="container mx-auto max-w-4xl bg-card rounded-2xl shadow-lg p-6 sm:p-8 grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-textPrimary mb-4">Nuestra Ubicación</h2>
          <p className="text-textSecondary text-base sm:text-lg mb-4">
            Visítanos en nuestra tienda física para una experiencia completa.
          </p>
          <p className="text-textPrimary font-semibold text-base sm:text-lg">Dirección:</p>
          <p className="text-textSecondary text-base sm:text-lg mb-4">Cl. 0 Nte. #6-02, Villa Del Rosario, Norte de Santander - Colombia</p>

          <h2 className="text-xl sm:text-2xl font-bold text-textPrimary mb-4">Información de Contacto</h2>
          <p className="text-textPrimary font-semibold text-base sm:text-lg">Teléfono:</p>
          <p className="text-textSecondary text-base sm:text-lg mb-4">+57 301 3346595</p>
          <p className="text-textPrimary font-semibold text-base sm:text-lg">Email:</p>
          <p className="text-textSecondary text-base sm:text-lg mb-4">info@atlantisfish.com</p>
          <p className="text-textPrimary font-semibold text-base sm:text-lg">Horario:</p>
          <p className="text-textSecondary text-base sm:text-lg">Lunes a Viernes: 8:00 AM - 6:00 PM</p>
          <p className="text-textSecondary text-base sm:text-lg">Sábados: 7:00 AM - 12:00 PM</p>
        </div>
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-textPrimary mb-4">Encuéntranos en el Mapa</h2>
          <div className="rounded-xl overflow-hidden shadow-md">
            <iframe
              src={googleMapsEmbedUrl}
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Atlantis Fish"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;